// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-9bb78152]{display:flex;flex-grow:1;align-items:center;justify-content:center;position:relative}.image-centered[data-v-9bb78152]{margin:auto}iframe[data-v-9bb78152]{position:absolute;width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
